var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 17.3407C15.78 17.3407 18.64 14.5007 19.61 13.5007C22.68 10.5007 21.15 4.32071 21.15 4.32071C21.15 4.32071 15 2.79071 12 5.86071C9.66 8.14071 8.14 9.72071 8.14 9.72071C8.14 9.72071 4.3 8.92071 2 11.2207L14.25 23.5007C16.55 21.1707 15.78 17.3407 15.78 17.3407ZM14.28 8.34071C14.4657 8.15475 14.6863 8.00724 14.9291 7.90659C15.1719 7.80594 15.4322 7.75413 15.695 7.75413C15.9578 7.75413 16.2181 7.80594 16.4609 7.90659C16.7037 8.00724 16.9243 8.15475 17.11 8.34071C17.3895 8.6205 17.5797 8.97687 17.6567 9.36477C17.7337 9.75267 17.694 10.1547 17.5425 10.52C17.3911 10.8853 17.1348 11.1976 16.8059 11.4172C16.4771 11.6369 16.0905 11.7541 15.695 11.7541C15.2995 11.7541 14.9129 11.6369 14.5841 11.4172C14.2552 11.1976 13.9989 10.8853 13.8475 10.52C13.696 10.1547 13.6563 9.75267 13.7333 9.36477C13.8103 8.97687 14.0005 8.6205 14.28 8.34071ZM3 22.5007C4.85107 22.4479 6.62315 21.7391 8 20.5007L5 17.5007C3 18.5007 3 22.5007 3 22.5007Z",
    fill: "#008AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7ca85c1e9e8eb40d99a55df859012625.svg";
export { ForwardRef as ReactComponent };